// Centralized high-resolution image library
// All Unsplash images use &w=1200 for crisp rendering on all screens

export const IMAGES = {
  // Dental consultation / doctor-patient interactions
  dentistConsulting: 'https://images.unsplash.com/photo-1606811842243-af7e16970c1f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  dentistSmiling: 'https://images.unsplash.com/photo-1663755787934-3742b0f5983a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  dentistTablet: 'https://images.unsplash.com/photo-1619691249147-c5689d88016b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  dentistExplainingXray: 'https://images.pexels.com/photos/5622261/pexels-photo-5622261.jpeg?auto=compress&cs=tinysrgb&w=1200',
  dentistXrayLaptop: 'https://images.pexels.com/photos/5622254/pexels-photo-5622254.jpeg?auto=compress&cs=tinysrgb&w=1200',
  dentalTreatment: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',

  // Happy patients / smiles
  happySmileCloseup: 'https://images.pexels.com/photos/17299920/pexels-photo-17299920.jpeg?auto=compress&cs=tinysrgb&w=1200',
  happyManSmiling: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  confidentYoungMan: 'https://images.pexels.com/photos/10883310/pexels-photo-10883310.jpeg?auto=compress&cs=tinysrgb&w=1200',
  womanSmiling: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  blondeSmiling: 'https://images.unsplash.com/photo-1758600436770-821223436cdc?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  smileTransformation: 'https://images.unsplash.com/photo-1776400985210-92f654712d30?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',

  // Dental office / clinic
  dentalOffice: 'https://images.unsplash.com/photo-1606374173750-a2fe6f17be1c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  dentalChair: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  modernClinic: 'https://images.unsplash.com/photo-1643660527098-559f89e45a92?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',

  // Trust / partnership
  doctorTrust: 'https://images.pexels.com/photos/5206923/pexels-photo-5206923.jpeg?auto=compress&cs=tinysrgb&w=1200',
  doctorHandshake: 'https://images.unsplash.com/photo-1686771416282-3888ddaf249b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',

  // About / team
  dentistExamining: 'https://images.unsplash.com/photo-1758205308181-d52b41e00cef?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  dentistWorking: 'https://images.unsplash.com/photo-1663185551550-f8f56529ac5e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',

  // Pexels high-res
  dentalExplaining: 'https://images.pexels.com/photos/4270095/pexels-photo-4270095.jpeg?auto=compress&cs=tinysrgb&w=1200',
};
